export const COMPARE_ORIGINAL_ID = 'original';

export const DEFAULT_LOOK_HISTORY_LIMIT = 16;

/**
 * Append a generated look; dedupe only when the image URL is identical (keep every distinct render).
 */
export function appendLookToHistory(
  prev,
  { image, label, idPrefix = 'look', extra = {} },
  limit = DEFAULT_LOOK_HISTORY_LIMIT,
) {
  if (!image) return prev;
  const entry = {
    id: `${idPrefix}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    label: String(label || 'Look').trim() || 'Look',
    image,
    ...extra,
  };
  const deduped = prev.filter((item) => item.image !== image);
  return [entry, ...deduped].slice(0, limit);
}

export function primeCompareSlotsForNewLook(entryId, setters) {
  const { setCompareLeftId, setCompareRightId, setComparePickSlot } = setters;
  setCompareLeftId(COMPARE_ORIGINAL_ID);
  setCompareRightId(entryId);
  setComparePickSlot?.('right');
}

/** Assign a rail thumbnail to the active left or right compare slot (Looks Studio behavior). */
export function resolveLookById(looks, lookId, originalSrc) {
  const id = String(lookId || '');
  if (!id) return null;
  if (id === COMPARE_ORIGINAL_ID) {
    return originalSrc
      ? { id: COMPARE_ORIGINAL_ID, label: 'Original', image: originalSrc }
      : null;
  }
  const list = Array.isArray(looks) ? looks : [];
  return list.find((item) => String(item.id) === id) || null;
}

/**
 * QR / download target: when comparing, uses the active left or right slot;
 * otherwise the latest generated result (or source photo).
 */
export function resolveStudioDownloadImage({
  comparing = false,
  looks = [],
  originalSrc = '',
  latestResultImage = '',
  sourceImage = '',
  comparePickSlot = 'right',
  compareLeftId = COMPARE_ORIGINAL_ID,
  compareRightId = null,
}) {
  const fallback = latestResultImage || sourceImage || originalSrc || '';
  if (!comparing || !looks.length) return fallback;
  const focusId =
    comparePickSlot === 'left'
      ? compareLeftId
      : compareRightId ?? looks[0]?.id ?? null;
  const entry = resolveLookById(looks, focusId, originalSrc);
  return entry?.image || fallback;
}

export function resolveStudioDownloadLabel({
  comparing = false,
  looks = [],
  originalSrc = '',
  comparePickSlot = 'right',
  compareLeftId = COMPARE_ORIGINAL_ID,
  compareRightId = null,
}) {
  if (!comparing || !looks.length) return '';
  const focusId =
    comparePickSlot === 'left'
      ? compareLeftId
      : compareRightId ?? looks[0]?.id ?? null;
  const entry = resolveLookById(looks, focusId, originalSrc);
  return entry?.label || '';
}

export function handleCompareLookSelect({
  lookId,
  comparePickSlot,
  compareLeftId,
  compareRightId,
  setCompareLeftId,
  setCompareRightId,
  setComparePickSlot,
}) {
  const id = String(lookId || '');
  if (!id) return;
  if (comparePickSlot === 'left') {
    if (id === String(compareLeftId)) {
      setComparePickSlot('right');
      return;
    }
    if (id === String(compareRightId)) {
      setCompareLeftId(compareRightId);
      setCompareRightId(compareLeftId);
    } else {
      setCompareLeftId(id);
    }
    setComparePickSlot('right');
    return;
  }
  if (id === String(compareRightId)) {
    setComparePickSlot('left');
    return;
  }
  if (id === String(compareLeftId)) {
    setCompareRightId(compareLeftId);
    setCompareLeftId(compareRightId);
  } else {
    setCompareRightId(id);
  }
  setComparePickSlot('left');
}
